import React from 'react';
import { applyLicense, validateLicense } from '../../../../../api/department';
import { getDepartments } from '../../../../../api/lookup';
import noti from '../../../../../actions/toast';
import AddLicensePage from './AddLicensePage';
import { useParams } from 'react-router-dom';

const AddLicense = (props) => {
  const [dept, setDept] = React.useState({ name: '' });
  const [invalidId, setInvalidFlag] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [info, updateInfo] = React.useState({});
  const [invalid, setInvalid] = React.useState('');
  const [errors, setErrors] = React.useState('');
  const [result, setResult] = React.useState(0);
  const { id } = useParams();
  React.useEffect(() => {
    getDepartments()
      .then(({ items }) => {
        const result = items.filter((item) => item.id === parseInt(id));
        if (result.length) {
          setDept(result[0]);
          setInvalidFlag(false);
        } else {
          setInvalidFlag(true);
        }
      })
      .catch((err) => console.log(err));
  }, [id]);
  const handleValidateLicense = (values) => {
    setLoading(true);
    setResult(0);
    setInvalid('');
    updateInfo({});
    validateLicense({ ...values, departmentId: parseInt(id) })
      .then((resp) => {
        setResult(1);
        updateInfo(resp);
      })
      .catch((err) => {
        setResult(2);
        setInvalid('Cannot decrypt license. Contact the license administrator');
      })
      .finally(() => setLoading(false));
  };
  const handleApplyLicense = (values) => {
    setLoading(true);
    applyLicense({ ...values, departmentId: parseInt(id) })
      .then((resp) => {
        noti.success('License is applied');
        props.history.push('/configure/departments');
      })
      .catch((err) => setErrors(err.response.data.error.message))
      .finally(() => setLoading(false));
  };

  return (
    <AddLicensePage
      invalidId={invalidId}
      dept={dept}
      onValidateLicense={handleValidateLicense}
      onApplyLicense={handleApplyLicense}
      loading={loading}
      info={info}
      invalid={invalid}
      result={result}
      errors={errors}
    />
  );
};

export default AddLicense;
